import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  view: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    height: "100%",
    minHeight: 0,
    padding: "16px",
    boxSizing: "border-box",
    overflow: "auto"
  },

  actionsRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0
  },

  actionButton: {
    textTransform: "none"
  },

  sortControl: {
    minWidth: 190
  },

  updatedAt: {
    marginLeft: "auto",
    fontSize: "12px",
    color: "#736973",
    whiteSpace: "nowrap"
  },

  loadingContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center"
  }
}));

export default useStyles;
